export default {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  ESC: 27,
  TAB: 9,
  BACKSLASH: 220,
  P: 80,
  BACKSPACE: 8,
  SPACE: 32
};



// WEBPACK FOOTER //
// ./src/javascripts/utils/keycodes.es6.js